const UPDATES = [
  { title: '反派千金的重生逆袭', chapter: '第128话', desc: '公主在宫廷宴会上意外揭露了阴谋', time: '2小时前', tag: '热门' },
  { title: '剑尊归来之无双天下', chapter: '第156话', desc: '剑尊独闯魔域，一人对战三大魔尊', time: '3小时前', tag: '新章' },
  { title: '社内恋爱禁止令', chapter: '第82话', desc: '秘密约会被同事撞见，两人陷入危机', time: '5小时前', tag: '热门' },
  { title: '异世界悠闲 farming 生活', chapter: '第96话', desc: '丰收祭典上出现了神秘的异世界访客', time: '6小时前', tag: '更新' },
  { title: '勇者退休后的慢生活', chapter: '第73话', desc: '退休勇者的小店迎来了第一位冒险者客人', time: '8小时前', tag: '更新' },
  { title: '灵笼：末世生存法则', chapter: '第64话', desc: '灯塔内部暗流涌动，新噬极兽形态曝光', time: '10小时前', tag: '热门' },
  { title: '帝少的千亿宠妻', chapter: '第201话', desc: '总裁终于发现了女主隐藏的身份秘密', time: '12小时前', tag: '新章' },
  { title: '重生之都市修仙', chapter: '第340话', desc: '渡劫成功后主角重返都市面对新挑战', time: '14小时前', tag: '更新' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          最近更新
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          实时追踪热门漫画的最新章节更新动态
        </p>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200 space-y-6">
            {UPDATES.map((item, i) => (
              <div key={`${item.title}-${item.chapter}`} className="relative group cursor-pointer">
                <div className="absolute -left-[2.15rem] top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50 group-hover:scale-125 transition-transform"></div>
                <div className="bg-background-100 rounded-xl p-4 md:p-5 ml-2 hover:bg-background-200/50 transition-colors">
                  <div className="flex items-start justify-between gap-3 mb-2">
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm font-semibold text-foreground-900 font-heading truncate">
                        {item.title}
                        <span className="text-primary-500 font-medium ml-2">{item.chapter}</span>
                      </h3>
                    </div>
                    <span className={`px-2 py-0.5 text-xs font-medium rounded whitespace-nowrap ${
                      item.tag === '热门' ? 'bg-primary-100 text-primary-600' :
                      item.tag === '新章' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1.5">{item.desc}</p>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}